<template>
    <div class="apprentice-simple-card lesson-overview">
        <header class="lesson-header">
            <h2 class="title">{{ lessonIn.title }}</h2>
            <b-button
                class="btn-show-slides"
                v-if="lessonIn.presentation"
                v-b-tooltip="$t('lesson_manual.show_slides')"
                variant="primary"
                @click="showSlides">
                {{ $t('lesson_manual.show_slides') }}
                <div class="icon">
                    <i class="fas fa-play"></i>
                </div>
            </b-button>
        </header>

        <design-2021-lesson-manual-lesson-goal-component
            v-if="lessonIn.goals.length > 0 || editable"
            :editable="editable"
            @lesson-updated="lessonUpdated"
            :lesson-in="lessonIn">
        </design-2021-lesson-manual-lesson-goal-component>

        <design-2021-lesson-manual-custom-goal-lists-component
            v-if="lessonIn.custom_goal_lists.length > 0 || editable"
            :editable="editable"
            :lesson-in="lessonIn"
            @lesson-updated="lessonUpdated">
        </design-2021-lesson-manual-custom-goal-lists-component>

        <design-2021-lesson-manual-lesson-files-component
            v-if="lessonIn.files.length > 0 || editable"
            :editable="editable"
            @lesson-updated="lessonUpdated"
            :lesson-in="lessonIn">
        </design-2021-lesson-manual-lesson-files-component>

        <design-2021-lesson-manual-lesson-skills-component
            v-if="lessonIn.skills.length > 0"
            :skills-in="lessonIn.skills">
        </design-2021-lesson-manual-lesson-skills-component>

        <design-2021-lesson-manual-lesson-preparation-component
            v-if="lessonIn.preparation !== null"
            :preparation-in="lessonIn.preparation">
        </design-2021-lesson-manual-lesson-preparation-component>

        <design-2021-lesson-manual-lesson-text-block-component
            v-if="lessonIn.text_blocks.length > 0 || editable"
            :lesson-in="lessonIn"
            @lesson-updated="lessonUpdated"
            :editable="editable">
        </design-2021-lesson-manual-lesson-text-block-component>

        <div
            class="lesson-controls"
            v-if="!lessonHaveNoContent()"></div>

        <div
            class="not-found with-header empty-lessons-manual"
            v-if="lessonHaveNoContent() && !editable">
            <div class="icon">
                <i class="fas fa-exclamation-circle"></i>
            </div>
            <div class="alert-notice">{{ $t('lesson.no_lesson_materials_found') }}</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'design-2021-lesson-manual-lesson-overview-component',
        props: {
            lessonIn: {
                type: Object,
                required: true
            },
            editable: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        methods: {
            showSlides() {
                window.location.href = this.routes.lessonManualLessonShowSlides(this.lessonIn.id);
            },
            lessonUpdated(newLesson) {
                this.$emit('lesson-updated', newLesson);
            },

            lessonHaveNoContent() {
                return (
                    this.lessonIn.goals.length === 0 &&
                    this.lessonIn.files.length === 0 &&
                    this.lessonIn.skills.length === 0 &&
                    this.lessonIn.preparation === null &&
                    this.lessonIn.text_blocks.length === 0
                );
            },
            createCustomGoalList() {
                this.$refs.createCustomGoalListModal.show();
            }
        }
    };
</script>

<style scoped lang="scss">
    .lesson-overview ::v-deep {
        background-color: $white;
        padding: map-get($grid-gutter-spacing, 'fifteen');
        border-radius: 0;

        .title {
            font-family: $headings-font-family;
            font-weight: $font-weight-bold;
            margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
        }

        .lesson-answer-sheet,
        .lesson-skills,
        .lesson-preparation {
            padding: map-get($grid-gutter-spacing, 'fifteen');
            background-color: var(--intermediateLighterColor);
        }

        > div {
            margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
        }
    }

    .lesson-header {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        row-gap: map-get($grid-gutter-spacing, 'ten');
        margin-bottom: $grid-gutter-width;
        width: 100%;

        .btn-show-slides {
            display: flex;
            align-items: flex-start;
            justify-content: center;
            column-gap: 18px;
            align-self: flex-end;
            order: 0;

            .icon {
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
                font-size: 0.75rem;
                width: 35px;
                height: 28px;
                top: 3px;

                i {
                    z-index: 10;
                    color: var(--primary);
                }

                &:before,
                &:after {
                    content: '';
                    position: absolute;
                    display: block;
                    background-color: $white;
                    border-radius: $border-radius-sm;
                    width: 33px;
                    height: 23px;
                }

                &:before {
                    left: -3px;
                    top: -3px;
                }

                &:after {
                    border: 2px solid var(--primary);
                    border-radius: 6px;
                }
            }

            &:hover {
                .icon {
                    i {
                        color: var(--primaryDarker);
                    }
                }
            }
        }

        .title {
            order: 1;
        }
    }

    @media (min-width: map-get($grid-breakpoints, 'md')) {
        .lesson-header {
            flex-direction: row;
            align-items: center;
            column-gap: $grid-gutter-width;
            flex-wrap: wrap;
            gap: map-get($grid-gutter-spacing, 'ten') $grid-gutter-width;

            .title {
                margin-bottom: 0;
                order: 0;
                flex: 1;
            }

            .btn-show-slides {
                flex: 0 0 auto;
                align-self: flex-start;
                margin-left: auto;
                order: 1;
            }
        }
    }
</style>
